import type { ConstraintDisplayMode } from '@/portfolio/proposal-builder/components/interactive-bar-chart/types'

/**
 * Checks if the display mode is valid dollar mode
 * @param displayMode - Display mode ('percentage' or 'market_value')
 * @param displayScaleFactor - Total investment amount (required for market_value mode)
 * @returns true if in market_value mode with valid scale factor
 *
 * @example
 * isDollarMode('market_value', 1000000) // true
 * isDollarMode('market_value', 0) // false (invalid scale)
 * isDollarMode('percentage', 1000000) // false
 */
export const isDollarMode = (
  displayMode: ConstraintDisplayMode,
  displayScaleFactor?: number,
): boolean => {
  return (
    displayMode === 'market_value' &&
    displayScaleFactor !== undefined &&
    displayScaleFactor > 0
  )
}
